import { baseApi } from "@/services/base-api";
import type { ChatMessage, Conversation } from "@/features/messaging/types/chat";

/**
 * docs/architecture/authentication.md lists `GET /chat` as a protected
 * route and docs/api/api-design.md's example set has `POST /chat` /
 * `GET /chat/:id/messages` — REST only covers creating a thread, listing
 * threads, and reading history. Actually *sending* a message is a Socket.IO
 * event (`send_message`, per docs/notes/sprint1.3.md's contract), not a
 * REST call — there's no `chat.api.ts` method for it.
 */
export const chatApi = {
  getConversations: () => baseApi.get<Conversation[]>("/chat"),

  /** Not part of docs/api/api-design.md's literal example list, but needed
   * for `ChatConversationPage` to render its header (pinned product, other
   * party) on a direct/reloaded visit to `/chat/:conversationId` — the
   * conversations list query won't always be populated yet at that point. */
  getConversation: (chatId: string) => baseApi.get<Conversation>(`/chat/${chatId}`),

  createOrGetChat: (productId: string) =>
    baseApi.post<Conversation, { productId: string }>("/chat", { productId }),

  getMessages: (chatId: string, page: number) =>
    baseApi.getPaginated<ChatMessage>(`/chat/${chatId}/messages`, { params: { page } }),
};
